{
  "header": "Documents",
  "noDocuments": "Aucun document disponible",
  "noDocumentsFiltered": "Aucun document ne correspond à vos critères de recherche",
  "errorStateTitleDocuments": "Impossible de charger les documents",
  "signed": "Signé",
  "notSigned": "Non signé",
  "signedExternally": "Signé en externe",
  "headerTabs": {
    "html": "HTML",
    "pdf": "PDF"
  },
  "tabs": {
    "tableHeaders": {
      "date": "Date",
      "name": "Nom",
      "frequency": "Fréquence"
    },
    "statements": {
      "title": "Relevés",
      "noDocuments": "Aucun relevé disponible",
      "noDocumentsFiltered": "Aucun relevé ne correspond à vos critères de recherche",
      "errorStateTitleDocuments": "Impossible de charger les relevés"
    },
    "agreements": {
      "title": "Accords",
      "noAgreements": "Vous n'avez actuellement aucun accord signé",
      "noAgreementsFiltered": "Aucun accord ne correspond à vos critères de recherche",
      "errorStateTitleAgreements": "Impossible de charger les accords",
      "uploadAgreement": "Importer {{agreementName}}"
    },
    "taxDocuments": {
      "title": "Documents fiscaux",
      "noDocuments": "Aucun document fiscal disponible",
      "noDocumentsFiltered": "Aucun document fiscal ne correspond à vos critères de recherche",
      "errorStateTitleDocuments": "Impossible de charger les documents fiscaux"
    },
    "uploadedDocuments": {
      "title": "Documents téléchargés",
      "noDocuments": "Aucun document disponible",
      "noDocumentsFiltered": "Aucun document ne correspond à vos critères de recherche",
      "errorStateTitleDocuments": "Impossible de charger les documents",
      "documentUploadedSuccessfully": "Le document a bien été importé : {{fileName}}"
    },
    "tradeConfirmations": {
      "title": "Confirmations d'opération",
      "noDocuments": "Aucune confirmation de transaction disponible",
      "noDocumentsFiltered": "Aucune confirmation de transaction ne correspond à vos critères de recherche",
      "errorStateTitleDocuments": "Impossible de charger les confirmations de transactions"
    },
    "clientReports": {
      "title": "Rapports clients",
      "noClientReports": "Aucun rapport client disponible",
      "noClientReportsFiltered": "Aucun rapport client ne correspond à vos critères de recherche",
      "errorStateTitleClientReports": "Impossible de charger les rapports clients"
    },
    "formCompletions": {
      "title": "Formulaires"
    }
  },
  "button": {
    "uploadDocuments": "Télécharger des documents",
    "uploadDocumentsMobile": "Télécharger",
    "uploadDocumentsEnhanced": "Ajouter"
  },
  "addDocumentModal": {
    "title": "Télécharger des documents",
    "subText": "Vous pouvez télécharger n'importe lequel de ces types de fichiers: .jpg, .csv, .jpeg, .pdf, ou .png.",
    "selectFile": "Sélectionner un fichier",
    "inputLabel": "Nom du document",
    "inputPlaceholder": "Écrivez le nom de votre document",
    "shareDocumentWithEveryone": "Partager le document avec tout le monde",
    "grantAccessDocument": "Accorder l'accès au document à",
    "grantAccessDocumentError": "Au moins un profil de rôle est requis",
    "button": {
      "upload": "Télécharger",
      "cancel": "Annuler"
    },
    "tabs": {
      "statements": {
        "title": "Télécharger des relevés"
      },
      "taxDocuments": {
        "title": "Télécharger des documents fiscaux"
      },
      "uploadedDocuments": {
        "title": "Télécharger des documents"
      },
      "tradeConfirmations": {
        "title": "Télécharger des confirmations de transactions"
      }
    }
  },
  "filter": {
    "any": "Tous",
    "button": {
      "applyFilters": "Appliquer",
      "resetFilters": "Effacer les filtres"
    },
    "date": "Date",
    "account": "Compte",
    "placeholder": {
      "selectAccount": "Sélectionnez un compte"
    },
    "dateOptions": {
      "YEAR_TO_DATE": "Depuis le début de l'année",
      "MONTH_TO_DATE": "Depuis le début du mois",
      "CUSTOM": "Date personnalisée"
    },
    "types": {
      "title": "Type",
      "accountStatements": {
        "MANAGEMENT_FEES_ANNUAL_REPORT": "Rapport annuel sur les frais de gestion",
        "ADMINISTRATIVE_FEES_ANNUAL_REPORT": "Rapport annuel sur les frais administratifs",
        "ANNUAL_PERFORMANCE_REPORT": "Rapport annuel de performance",
        "OV_MONTHLY_ACCOUNT_STATEMENTS": "Relevés mensuels de compte OneVest",
        "MONTHLY_ACCOUNT_STATEMENTS": "Relevés de compte mensuels",
        "ANNUAL_ACCOUNT_STATEMENTS": "Relevés de compte annuels",
        "QUARTERLY_ACCOUNT_STATEMENTS": "Relevés de compte trimestriels",
        "CONSOLIDATED_MONTHLY_ACCOUNT_STATEMENTS": "Relevé de compte mensuel consolidé",
        "ACCOUNT_STATEMENT": "Relevés de compte",
        "TAX_SLIPS_LAST_10_MONTHS": "Relevés fiscaux des 10 derniers mois",
        "TAX_SLIPS_FIRST_60_DAYS": "Relevés fiscaux des 60 premiers jours",
        "TAX_SLIPS_T4RSP_RL2": "Relevés fiscaux T4RSP RL2",
        "TAX_SLIPS_T4RIF_RL2": "Relevés fiscaux T4RIF RL2",
        "TAX_SLIPS_T4A_RL1": "Relevés fiscaux T4A RL1",
        "TAX_SLIPS_NR4": "Relevés fiscaux NR4",
        "TAX_SLIPS_T5008": "Relevés fiscaux T5008",
        "TAX_SLIPS_TRADING_SUMMARY": "Résumé des opérations sur les relevés fiscaux",
        "TAX_SLIPS_T5_RL3": "Relevés fiscaux T5 RL3",
        "TAX_SLIPS_T3_RL16": "Relevés fiscaux T3 RL16",
        "TAX_SLIPS_T3_BREAKDOWN": "Détails des relevés fiscaux T3",
        "TAX_SLIPS_T5013_RL15": "Relevés fiscaux T5013 RL15",
        "TAX_SLIP_GENERAL": "Relevé fiscal général",
        "TAX_SLIPS_T4_FHSA": "Relevés fiscaux T4 FHSA",
        "TAX_SLIPS_REST_OF_YEAR": "Relevés fiscaux du reste de l'année",
        "TAX_SLIPS_RL2": "Relevés fiscaux RL2",
        "TAX_SLIPS_T3": "Relevés fiscaux T3",
        "TAX_SLIPS_T5": "Relevés fiscaux T5",
        "TAX_SLIPS_T4RIF": "Relevés fiscaux T4RIF",
        "TAX_SLIPS_T4A": "Relevés fiscaux T4A",
        "TAX_SLIPS_T4RSP": "Relevés fiscaux T4RSP",
        "TRADE_CONFIRMATION": "Confirmations de transaction"
      },
      "clientReports": {
        "ACCOUNT": "Compte",
        "GOAL": "Objectif",
        "SUB_ACCOUNT": "Sous-compte",
        "CLIENT_GROUP": "Groupe de clients",
        "INDIVIDUAL": "Entités individuelles",
        "NON_INDIVIDUAL": "Entités non individuelles",
        "ACCOUNT_GROUP": "Groupe de comptes"
      }
    },
    "taxYear": "Année fiscale",
    "taxYearError": "Entrez une année valide à 4 chiffres entre 1900 et {{currentYear}}"
  },
  "droppableFileInput": {
    "dragFilesHere": "Faire glisser et déposer un fichier ici",
    "or": "ou",
    "chooseAFile": "Parcourir un fichier",
    "clickToBrowse": "Faites glisser le fichier ici ou cliquez pour naviguer",
    "browse": "Naviguer",
    "chooseAnotherFile": "En choisir un autre",
    "fileSize": "Taille des documents",
    "maxDocumentSize": "Taille maximale du document: {{fileMaxSize}} Mo",
    "max": "Maximum : {{fileMaxSize}} Mo",
    "documentRequired": "Un document doit être joint",
    "fileIsAboveMaxSize": "La taille du fichier ({{size}}) est supérieure à la taille maximale",
    "fileIsUnsupportedType": "Type de fichier ({{type}}) non pris en charge. Veuillez en utiliser un parmi les suivants : {{acceptedTypes}}",
    "submit": "Télécharger"
  },
  "editDocumentModal": {
    "tabs": {
      "statements": {
        "title": "Modifier le relevé",
        "documentName": "Nom du relevé"
      },
      "taxDocuments": {
        "title": "Modifier le document fiscal",
        "documentName": "Nom du document fiscal"
      },
      "uploadedDocuments": {
        "title": "Modifier le document",
        "documentName": "Nom du document"
      },
      "tradeConfirmations": {
        "title": "Modifier la confirmation de transaction",
        "documentName": "Nom de la confirmation de transaction"
      }
    }
  },
  "formCompletions": {
    "table": {
      "name": "Nom",
      "package": "Lot",
      "signedBy": "Signé par",
      "signedAt": "Signé à"
    }
  },
  "downloadDocuments": {
    "downloadedSuccessfully": "Documents téléchargés avec succès",
    "downloadedPartially": "Documents téléchargés partiellement: {{successCount}} sur {{totalFiles}}",
    "downloadFailed": "Échec du téléchargement des documents"
  }
}
